import { getClosest, supportTransitions, emulateTransitionEnd, customEvent } from './utils';

export default element => {
	var Tab = function (element) {
		var self = this;
		var heightData = element.getAttribute('data-height');
		var height = supportTransitions ? (heightData === 'true') : false;
		var next, activeTab, activeContent, nextContent, containerHeight, equalContents, nextHeight;
		var tabsContentContainer = false;
		var tabs = getClosest(element, '.nav-tabs');

		// triggers
		var triggerEnd = function () {
			tabsContentContainer.style.height = '';
			tabsContentContainer.classList.remove('collapsing');
			tabs.isAnimating = false;
		};

		var triggerShow = function () {
			if (tabsContentContainer) { // height animation
				if (equalContents) {
					triggerEnd();
				} else {
					setTimeout(function () { // enables height animation
						tabsContentContainer.style.height = nextHeight + 'px'; // height animation
						tabsContentContainer.offsetWidth;
						emulateTransitionEnd(tabsContentContainer, triggerEnd);
					}, 50);
				}
			} else {
				tabs.isAnimating = false;
			}
			customEvent.call(next, 'tab', 'shown', activeTab);
		};

		var triggerHide = function () {
			if (tabsContentContainer) {
				activeContent.style.float = left;
				nextContent.style.float = left;
				containerHeight = activeContent.scrollHeight;
			}

			nextContent.classList.add('active');
			customEvent.call(next, 'tab', 'show', activeTab);

			activeContent.classList.remove('active');
			customEvent.call(activeTab, 'tab', 'hidden', next);

			if (tabsContentContainer) {
				nextHeight = nextContent.scrollHeight;
				equalContents = nextHeight === containerHeight;

				tabsContentContainer.classList.add('collapsing');
				tabsContentContainer.style.height = containerHeight + 'px'; // height animation
				tabsContentContainer.offsetHeight;
				activeContent.style.float = '';
				nextContent.style.float = '';
			}

			if (nextContent.classList.contains('fade')) {
				setTimeout(function () {
					nextClass.classList.add('show');
					emulateTransitionEnd(nextContent, triggerShow);
				}, 20);
			} else {
				triggerShow();
			}
		};

		// invalidate
		if (!tabs) return;

		// set default animation state
		tabs.isAnimating = false;

		var getActiveTab = function () {
			var activeTab;
			var activeTabs = [].slice.call(tabs.getElementsByClassName('active'));

			if (activeTabs.length === 1) {
				activeTab = activeTabs[0];
			} else if (activeTabs.length > 1) {
				activeTab = activeTabs[activeTabs.length - 1];
			}

			return activeTab;
		};

		var getActiveContent = function () {
			return document.querySelector(getActiveTab().getAttribute('href'));
		};

		var clickHandler = function (e) {
			e.preventDefault();

			next = e.currentTarget;
			!tabs.isAnimating && !next.classList.contains('active') && self.show();
		};

		// public method
		this.show = function () { // the tab we clicked is now the next tab
			next = next || element;
			nextContent = document.querySelector(next.getAttribute('href'));
			activeTab = getActiveTab();
			activeContent = getActiveContent();

			tabs.isAnimating = true;
			activeTab.classList.remove('active');
			activeTab.setAttribute('aria-selected', 'false');
			next.classList.add('active');
			next.setAttribute('aria-selected', 'true');

			customEvent.call(activeTab, 'tab', 'hide', next);

			if (activeContent.classList.contains('fade')) {
				activeContent.classList.remove('show');
				emulateTransitionEnd(activeContent, triggerHide);
			} else {
				triggerHide();
			}
		};

		// init
		if (!('Tabs' in element)) { // prevent adding event handlers twice
			element.addEventListener('click', clickHandler, false);
		}

		if (self.height) {
			tabsContentContainer = getActiveContent().parentNode;
		}

		element.Tabs = self;
	};

	// Initialize Tab
	var elements = element.querySelectorAll('[data-toggle="tab"]');
	for (var i = 0; i < elements.length; i++) {
		new Tab(elements[i]);
	}
};
